/* eslint-disable no-case-declarations */
import { PATIENT_BANNER_RESET } from '../../PatientFolder/PatientBanner/actions.js'
import { ENCOUNTER_RESET, ENCOUNTER_SIGNED } from '../actions.js'

import {
  SAVE_ENCOUNTER_FORM,
  RESET_ENCOUNTER_FORM,
  SAVE_ENCOUNTER_TYPE,
  RESET_ENCOUNTER_TYPE
} from './actions.js'

const initialState = {}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case SAVE_ENCOUNTER_FORM:
      const { formState } = action
      return {
        ...state,
        formState
      }
    case RESET_ENCOUNTER_FORM:
      return {
        ...state,
        formState: {}
      }
    case SAVE_ENCOUNTER_TYPE:
      const { encounterType } = action
      return {
        ...state,
        encounterType
      }
    case RESET_ENCOUNTER_TYPE:
      return {
        ...state,
        encounterType: null
      }
    case ENCOUNTER_RESET:
    case ENCOUNTER_SIGNED:
    case PATIENT_BANNER_RESET:
      return { ...initialState }
    default:
      return { ...state }
  }
}
